import { Button, Input, Pagination, SortingState, Table } from "@/components";
import DateRangePicker from "@/components/DateRangePicker";
import { useNotificationStore } from "@/store/notificationStore";
import { Notification, NotificationStatus, RoleEnum } from "@/types";
import { endOfDay } from "date-fns";
import React from "react";
import { IoIosSearch } from "react-icons/io";
import { useNotificationTable } from "../hooks";

type Props = {
  setOpenNew?: (open: boolean) => void;
  role: RoleEnum;
};

const NotificationTable: React.FC<Props> = ({ setOpenNew, role }: Props) => {
  const {
    columns,
    searchTerm,
    setSearchTerm,
    filters,
    setFilters,
    notifications,
    isLoading,
    error,
    pagination,
    setPage,
    renderAction,
  } = useNotificationTable();
  const { openEditModal } = useNotificationStore();

  if (error) throw error;

  const handleDateChange = (dateRange: { start: string; end: string }) => {
    setFilters((prev) => ({
      ...prev,
      startDate: dateRange.start,
      endDate: dateRange.end ? endOfDay(dateRange.end) : undefined,
    }));
  };

  const openCreateDrawer = () => {
    setOpenNew?.(true);
  };

  const handleOnRow = (notification: Notification) => {
    if (notification.status !== NotificationStatus.DRAFT) return;
    openEditModal(notification.id);
  };

  const handleSortingChange = (sorting: SortingState<Notification>) => {
    setFilters({ ...sorting });
  };

  // Với role user hoặc other ẩn button tạo mới
  // tạm thời ẩn table với role member
  const isMemberRole = role === RoleEnum.USER || role === RoleEnum.OTHER;

  return (
    <>
      <div className="space-y-4">
        <div className="flex flex-wrap items-center gap-2 py-4 justify-start">
          <Input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="通知テーマで検索"
            icon={<IoIosSearch className="size-4" />}
            className="!h-10 w-80"
          />

          <DateRangePicker
            containerClassName="md:ml-auto"
            value={{
              start: filters.startDate || "",
              end: filters.endDate || "",
            }}
            onChange={handleDateChange}
          />

          {!isMemberRole && (
            <Button
              type="button"
              variant="solid"
              color="primary"
              className="h-10"
              onClick={openCreateDrawer}
            >
              新規作成
            </Button>
          )}
        </div>
        {!isMemberRole && (
          <>
            <Table<Notification>
              columns={columns as any}
              dataSource={notifications}
              loading={isLoading}
              bordered
              showAction
              renderAction={renderAction}
              onRow={(record) => {
                return {
                  onClick: () => {
                    handleOnRow(record);
                  },
                };
              }}
              onSortingChange={handleSortingChange}
            />
            {pagination && (
              <Pagination
                currentPage={pagination.page}
                totalPages={pagination.pageCount}
                onPageChange={setPage}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default NotificationTable;
